import type { IComponentOptions } from "angular";
import { ButtonComponent } from "App/Modules/Gui/Components/Button/Common/ButtonComponent";
import { ButtonComponentController } from "../Common/ButtonComponentController";

import "../Common/Button.scss";
import "./EditButton.html";
import "./EditButton.scss";

export class EditButtonComponent extends ButtonComponent implements IComponentOptions {
    public controller = ButtonComponentController;

    public templateUrl = "/App/Modules/Gui/Components/Button/EditButton/EditButton.html";
}
